export const NEW_TAB = 'New Tab';
export const TARGET_BLANK = '_blank';
export const TARGET_SELF = '_self';
export const PRIMARY_BUTTON_STYLE = 'primary';
export const SECONDARY_BUTTON_STYLE = 'table-header';
export const TEXT_COLOR_WHITE = 'white';
export const TEXT_ALIGNMENT_CENTER = 'center';
export const PRIVACTY_OPTIONS_ICON_NAME = 'privacyoptions';
